module.exports = __webpack_public_path__ + "static/media/low-instrumental.a7147204.png";